import React, { Component } from 'react'
import { getfullName, getUserId } from 'Lib'
import { Button, Modal, Form, TextArea, Input, Grid, Dropdown } from 'semantic-ui-react'
import RoomManager from '../../../../business/RoomManager'
import Loading from 'Features/ui/components/Loading'
import ReportManager from '../../../../business/ReportManager'

class CustomModel extends Component {
    constructor(props) {
        super(props)
        this.state = {
            // open: open,
            contentValid: '',
            roomValid: '',
            content: '',
            room: '0',

            rooms: [],
            isLoading: false,

            customModal: null
        }
        this.bRoom = new RoomManager()
        this.bReport = new ReportManager()
    }

    componentDidMount() {
        this.onGetRoom()
    }

    onGetRoom = () => {
        this.setState({
            isLoading: true
        }, async () => {
            let res = await this.bRoom.findAllRoom()
            let tempState = {
                rooms: [],
                isLoading: false
            }
            if (!!res && res.result === true) {
                if (Array.isArray(res.data)) {
                    tempState.rooms = res.data
                }
            }
            this.setState(tempState)
        })
    }

    handleChange = (e, { value, name }) => this.setState({ [name]: value })

    validate = () => {
        let isValid = true
            , tempState = {}
        const { content, room } = this.state
        if (!!content) {
            tempState.contentValid = ""
        } else {
            isValid = false
            tempState.contentValid = "Require!!"
        }
        if (!!room && room !== "0") {
            tempState.roomValid = ""
        } else {
            isValid = false
            tempState.roomValid = "Require!!"
        }
        this.setState(tempState, () => {
            if (isValid) {
                this.onSendReport()
            }
        })
    }

    onSendReport = () => {
        this.setState({
            isLoading: true
        }, async () => {
            const { content, room } = this.state

            let body = {
                detail: content,
                roomId: room,
                userId: getUserId(),
                // roomName: room,
                // ReportBy: getfullName()
            }
            let res = await this.bReport.sendReport(body)
            let tempState = {
                isLoading: false
            },
                action = () => { }
            if (!!res && res.result === true) {
                action = this.props.onClose
            } else {
                tempState.customModal = {
                    open: true,
                    content: <div>
                        {
                            !!res && Array.isArray(res.errors) && res.errors.length > 0 ?
                                <div>
                                    {
                                        res.errors.map((err, i) => {
                                            return <div key={i}>
                                                <p>Error Code : {err.code}</p>
                                                <p>Error Message : {err.message}</p>
                                            </div>
                                        })
                                    }
                                </div>
                                : <React.Fragment>
                                    <p>Error Code : </p>
                                    <p>Error Message : </p>
                                </React.Fragment>
                        }
                    </div>,
                    onCose: () => {
                        this.setState({
                            customModal: null
                        })
                    }
                }
            }
            this.setState(tempState, action)
        })
    }

    selected() {
        this.validate(this.state)
    }

    render() {
        const { onClose } = this.props
        const { dimmer, rooms, room, isLoading, customModal } = this.state

        let name = getfullName()
        let report = 'Report By : ' + name

        let optionsRoom = [
            {
                key: "0",
                value: "0",
                text: "-- Please Select --"
            }
        ]
        rooms.forEach(r => {
            optionsRoom.push({
                key: r._id,
                value: r._id,
                text: r.name
            })
        });
        return (
            <React.Fragment>
                <Modal open={true} dimmer={dimmer} className="modalDanger">
                    {isLoading && <Loading />}
                    <Modal.Header style={{ textAlign: 'center' }}>Report Administrator</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form>
                                <Grid>
                                    <Grid.Row style={{ padding: 0 }}>
                                        <Grid.Column width={13}>
                                            <Form.Field control={TextArea} label='Content' name='content' placeholder='Reason' onChange={this.handleChange} style={{ display: 'inline' }} />
                                        </Grid.Column>
                                        <Grid.Column width={3} verticalAlign='middle'>
                                            <div className='errors'>{this.state.contentValid}</div>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row >
                                        <Grid.Column width={16} verticalAlign='middle'>
                                            <p style={{ fontWeight: "bold" }}>Room</p>
                                        </Grid.Column>
                                        <Grid.Column width={8}>
                                            <Dropdown
                                                search
                                                selection
                                                options={optionsRoom}
                                                fluid
                                                value={room}
                                                name='room'
                                                onChange={this.handleChange}
                                            />
                                        </Grid.Column>
                                        <Grid.Column width={3} verticalAlign='middle'>
                                            <div className='errors'>{this.state.roomValid}</div>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row style={{ padding: 0 }}>
                                        <Grid.Column width={16} verticalAlign='middle'>
                                            <Form.Field label={report} />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>

                    </Modal.Content>
                    <Modal.Actions>
                        <Button color="blue" style={{ width: '100px' }} onClick={this.validate}>Ok</Button>
                        <Button color="grey" style={{ width: '100px' }} onClick={onClose}>Cancel</Button>
                    </Modal.Actions>
                </Modal>
                {
                    !!customModal &&
                    <Modal open={customModal.open} onClose={this.close}>
                        <Modal.Header>Something went wrong !</Modal.Header>
                        <Modal.Content>
                            <Modal.Description>
                                {/* <h2>{statusText}</h2> */}
                                {/* <p>Error Code : {errorCode}</p>
                                <p>Error Message : {errorMessage}</p> */}
                                {customModal.content}
                            </Modal.Description>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button
                                positive
                                icon='checkmark'
                                labelPosition='right'
                                content="OK"
                                onClick={customModal.onCose}
                            />
                        </Modal.Actions>
                    </Modal>
                }
            </React.Fragment>
        )
    }
}

export default CustomModel


// WEBPACK FOOTER //
// ./src/features/ui/components/Model/Report.js